import { useMPEFetch, useMutateMPEFetch } from '@retail/app/hooks';
import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { useAuthContext } from '@retail/auth/data-access';
import { mpeApi } from '@retail/mgpris/config';
import { MgItemWithTagsDTO, UpdateOrCreateSupplierItemTag } from '@retail/products/types';
import { QueryOptions } from '@shared/fetch-utils';
import { buildUrl } from '@shared/utils';

export interface AssortmentTagItemsProps {
  tagId: number;
  assortmentId: number;
}

export const useCreateOrUpdateSupplierItemAssortmentTags = (queryOptions: QueryOptions = {}) => {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMutateMPEFetch<void, UpdateOrCreateSupplierItemTag, AssortmentTagItemsProps>({
    url: ({ tagId, assortmentId }) =>
      buildUrl({
        base: mpe.url,
        route: mpeApi.assortmentTags.tagId.assortments.assortment.items.getFullLinkPath({
          tagId,
          assortmentId,
        }),
      }),
    method: 'POST',
    token,
    ...queryOptions,
  });
};

export interface DeleteProps extends AssortmentTagItemsProps {
  supplierItemId: number;
}

export const useDeleteSupplierItemAssortmentTag = (queryOptions: QueryOptions = {}) => {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMutateMPEFetch<void, void, DeleteProps>({
    url: ({ tagId, assortmentId, supplierItemId }) =>
      buildUrl({
        base: mpe.url,
        route:
          mpeApi.assortmentTags.tagId.assortments.assortment.items.supplierItem.getFullLinkPath({
            tagId,
            assortmentId,
            supplierItemId,
          }),
      }),
    method: 'DELETE',
    token,
    ...queryOptions,
  });
};

interface Props extends QueryOptions {
  assortmentId: number;
  mgItemNumber: number;
}

export const useFetchSupplierItemAssortmentTags = ({
  assortmentId,
  mgItemNumber,
  ...queryOptions
}: Props) => {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMPEFetch<MgItemWithTagsDTO>({
    method: 'GET',
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.mgItems.mgItemNumber.itemCard.assortmentTags.getFullLinkPath({ mgItemNumber }),
      searchParams: { assortmentId },
    }),
    token,
    queryKey: ['mg-item-assortment-tags', mgItemNumber],
    ...queryOptions,
  });
};
